import {Paper, styled} from '@mui/material';
import {reverse} from 'named-urls';
import React, {useEffect, useMemo, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Switched from '../../../../components/Switched';
import Switcher from '../../../../components/Switcher';
import routes from '../../../../routes';
import Emails from '../OutboundMessages/Table';
import Activity from './Activity';
import Items from './Items';
import Payments from './Payments';

const Container = styled(Paper)(({theme}) => ({
  '&.MuiPaper-root': {
    overflow: 'hidden',
    marginTop: theme.spacing(1),
  }
}));

const Tabs = ({invoice, onInvoiceUpdated, loading, onLoading, toggleError, contacts}) => {
  const match = useRouteMatch();
  const [tab, setTab] = useState('loading');

  const tabs = useMemo(() => [
    {
      title: 'Items',
      slug: '',
      path: reverse(invoice.archived ? routes.archive.invoice.detail : routes.invoices.detail, {
        id: invoice?.id ?? 0,
        tab: ''
      })
    },
    ...(invoice.published_at ? [{
      title: 'Payments',
      slug: 'payments',
      path: reverse(invoice.archived ? routes.archive.invoices.tab : routes.invoices.tab, {
        id: invoice?.id ?? 0,
        tab: 'payments'
      })
    }] : []),
    {
      title: 'Activity',
      slug: 'activity',
      path: reverse(invoice.archived ? routes.archive.invoices.tab : routes.invoices.tab, {
        id: invoice?.id ?? 0,
        tab: 'activity'
      })
    },
    {
      title: 'Emails',
      slug: 'emails',
      path: reverse(invoice.archived ? routes.archive.invoices.tab : routes.invoices.tab, {
        id: invoice?.id ?? 0,
        tab: 'emails'
      })
    }
  ], [invoice]);

  useEffect(() => {
    if (match.params?.tab && tabs.findIndex(t => t.slug) >= 0) {
      setTab(match.params?.tab);
    } else {
      setTab('');
    }
  }, [match, tabs]);

  return (
    <>
      <Switcher tabs={tabs}/>
      <Switched tab="" currentTab={tab}>
        <Container>
          <Items invoice={invoice} onInvoiceUpdated={onInvoiceUpdated} loading={loading}/>
        </Container>
      </Switched>
      <Switched tab="payments" currentTab={tab}>
        <Container>
          <Payments invoice={invoice} onInvoiceUpdated={onInvoiceUpdated} loading={loading} contacts={contacts}/>
        </Container>
      </Switched>
      <Switched tab="activity" currentTab={tab}>
        <Activity invoice={invoice} onLoading={onLoading} toggleError={toggleError}/>
      </Switched>
      <Switched tab="emails" currentTab={tab}>
        <Container>
          <Emails invoice={invoice}/>
        </Container>
      </Switched>
    </>
  );
};

export default Tabs;
